import React, { useState, useContext, useEffect } from 'react';
import { MenuItem, ListSubheader, TextField, InputAdornment, Select, FormControl, InputBase } from '@material-ui/core';
import { withStyles, makeStyles } from '@material-ui/core/styles';
import SearchIcon from '@material-ui/icons/Search';
import { Context } from "../contexts/siteContext";
import { User } from '../contexts/userContext.js';
import { Modules } from '../contexts/modulesContext';
import { Weather } from "../contexts/weatherContext";
import { LoadOfflineDatas, RemoveOfflineDatas } from '../../offline/dataService/offlineData';

const BootstrapInput = withStyles(theme => ({
    root: {
        width: '500px'
    },
    input: {
        borderRadius: 4,
        position: 'relative',
        backgroundColor: theme.palette.background.paper,
        border: '1px solid #ced4da',
        fontSize: 16,
        width: '500px',
        padding: '10px 26px 10px 12px',
        transition: theme.transitions.create(['border-color', 'box-shadow']),
        // Use the system font instead of the default Roboto font.
        fontFamily: [
            '-apple-system',
            'BlinkMacSystemFont',
            '"Segoe UI"',
            'Roboto',
            '"Helvetica Neue"',
            'Arial',
            'sans-serif',
            '"Apple Color Emoji"',
            '"Segoe UI Emoji"',
            '"Segoe UI Symbol"',
        ].join(','),
        '&:focus': {
            borderRadius: 4,
            borderColor: '#80bdff',
            boxShadow: '0 0 0 0.2rem rgba(0,123,255,.25)',
        },
    },
}))(InputBase);

const useStyles = makeStyles(theme => ({
    root: {
        margin: '0 auto'
    }
}));

const SiteList = (props) => {
    const classes = useStyles();
    const { sites, defaultSite, setDefaultSite } = useContext(Context);
    const { userDetail } = useContext(User);
    const { modules } = useContext(Modules);
    const { getWeather } = useContext(Weather);
    const [siteList, setSiteList] = useState(sites);
    const [siteId, setSiteId] = useState("");

    const searchSite = (event) => {
        let searchName = event.target.value.toLowerCase();
        let list = sites.filter((el) => {
            let searchValue = el.name.toLowerCase();
            if (searchName.length > 0) {
                return searchValue.indexOf(searchName) !== -1;
            }
            else {
                return searchValue;
            }
        });
        setSiteList(list);
    };

    const setSite = () => {
        let list = sites.filter((el) => {
            return  el.name.toLowerCase();
        });
        
        setSiteList(list);
        setSiteId(defaultSite.id);
    };

    const handleChange = (event) => {
        if (sessionStorage.getItem("isOffline") === "1")
            return;

        let site = siteList.filter(x => x.id === event.target.value)[0];
        if (site === undefined)
            return;

        setSiteId(site.id);
        RemoveOfflineDatas(defaultSite.id);
        setDefaultSite(site);
        LoadOfflineDatas(site, modules, true, userDetail.PplPerson.toString());
        getWeather(site.zipCode);
        sessionStorage.setItem("defaultSite", JSON.stringify(site));
    };

    const handleClose = (event) => {
        setSiteList(sites);
    };

    useEffect(() => {
        if (defaultSite.id > 0) {
            setSite();
        }
        // eslint-disable-next-line 
    }, [defaultSite.id]);

    return (
        <div className={classes.root}>
            <FormControl>
                <Select
                    MenuProps={{ autoFocus: false }}
                    value={siteId}
                    onChange={handleChange}
                    onClose={handleClose}
                    input={<BootstrapInput name="site" id="DefaultSiteDisplay" />}
                >
                    <ListSubheader>
                        <TextField
                            autoFocus
                            fullWidth
                            size="small"
                            placeholder="Search..."
                            InputProps={{
                                startAdornment: (
                                    <InputAdornment position="start">
                                        <SearchIcon />
                                    </InputAdornment>
                                )
                            }}
                            onChange={searchSite}
                            onKeyDown={(e) => {
                                if (e.key !== "Escape") {
                                    // Prevents autoselecting item while typing (default Select behaviour)
                                    e.stopPropagation();
                                }
                            }}
                        />
                    </ListSubheader>
                    {
                        siteList.map((site) => {
                            return (
                                <MenuItem key={site.id} value={site.id}>{site.name}</MenuItem>
                            )
                        })
                    }
                </Select>
            </FormControl>            
        </div>
    )
}
export default React.memo(SiteList);
